import { FC } from 'react';

export const NotFound: FC = () => {
    return (
        <div className="container">
            <div className="tmp-page-content">Page Not Found</div>
        </div>
    );
};
